import { DataSourceWithGenerics, SearchQueryFn } from "@me8eon/data_sources";
import { DataHasType } from "@me8eon/data";
import { _makeGraphApiRequest, filtersToQueryString, GraphApiContext, GraphApiFilters, GraphApiPaging, GraphApiQuery } from "./graph.api.data.sources";
import { departmentTypeFilterPluginName, DepartmentTypeString } from "@me8eon/departmenttype_filter";

export const graphApiPeople = "graphApiPeople";
export const searchBodyForPeopleGraphApi = (query: string, departmentType: DepartmentTypeString, isAggrFilter?: boolean): GraphApiQuery => {
    return {
        "requests": [
            {
                "entityTypes": ["people"],
                "query": {
                    "queryString": `${query.trim()}${departmentType ? ` ${departmentType}` : ""}`,
                },
                "selectProperties": [
                    "displayName",
                    "jobTitle",
                    "mobilePhone",
                    "businessPhones",
                    "aboutMe",
                    "hitHighlightedSummary",
                ],
            },

        ],
    };

};
export const graphApiPeopleQuery = <Filters extends GraphApiFilters>(): SearchQueryFn<Filters, GraphApiPaging, GraphApiQuery> =>
    ({ filters }) => ({
        query: searchBodyForPeopleGraphApi(filtersToQueryString(filters), filters[departmentTypeFilterPluginName]),
        filters,
    });

export function graphApiPeopleDs<Filters extends GraphApiFilters>({ graphApiUrl, token, MakeGraphApiRequest = _makeGraphApiRequest }: GraphApiContext): DataSourceWithGenerics<Filters, GraphApiPaging, GraphApiQuery, any, DataHasType[]> {
    return {
        type: graphApiPeople,
        plugin: "datasource",
        results: (devModeData, source, debug) => {
            debug("graphApiPeopleDs", devModeData);
            const hitContainers = devModeData.flatMap((d: any) => d.hitsContainers || []);
            const results = hitContainers.flatMap((d: any) => d.hits || []).map((d: any) => ({ type: "person", ...d, source }));
            return { paging: {}, results, finished: true, aggregates: {} };
        },
        query: graphApiPeopleQuery(),
        search: (query) => MakeGraphApiRequest(graphApiUrl, token, query),
    };
}